import IconArrowRight from './arrowRight.svg';

export default IconArrowRight;
